import { IFilterSelection } from '@studyportals/search-page-interface';
import { FilterKey } from '@studyportals/search-filters';
import { FilterSelection } from './FilterSelection';
import { FilterPersistenceValue } from './FilterPersistenceValue';
import { IDataStorage } from './IDataStorage';

export class FilterPersistence {
	private readonly ignoredFilters: readonly FilterKey[] = [FilterKey.KEYWORD_WHAT, FilterKey.KEYWORD_WHERE];

	private readonly version = '1.0';
	private readonly storageKey = 'SearchFilterSelection';

	private _dataStorage: IDataStorage | undefined;

	public constructor(dataStorage: IDataStorage | undefined) {
		this._dataStorage = dataStorage;
	}

	private get dataStorage(): IDataStorage {
		if (this._dataStorage === undefined) {
			throw new Error('DataStorage has not been provided');
		}

		return this._dataStorage;
	}

	public updateFrom(filters: IFilterSelection): void {
		const before = this.retrieve();
		const after = new FilterSelection(before, this.ignoredFilters).merge(filters).selection;

		const value = new FilterPersistenceValue(this.version, after);
		this.dataStorage.store(this.storageKey, JSON.stringify(value));
	}

	public retrieve(version: string = this.version): IFilterSelection {
		const value: unknown = this.dataStorage.retrieve(this.storageKey);
		if (typeof value !== 'string' || value.trim().length === 0) {
			return {};
		}

		const parsed = JSON.parse(value);
		if (FilterPersistenceValue.is(parsed) && parsed.version === version) {
			return parsed.filters;
		}

		return {};
	}
}
